import moment from "moment";
import Cookies from "js-cookie";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "./constant";

// format price $1, -$1
export function formatPrice(value, currencySymbols = "$") {
  // convert into number if value is string
  const numberValue =
    typeof value === "string" ? parseFloat(value) : Number(value);

  // check if numberValue is NaN
  if (isNaN(numberValue)) {
    return "Invalid value";
  }

  const formatted = Math.abs(numberValue).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return numberValue >= 0
    ? `${currencySymbols}${formatted}`
    : `-${currencySymbols}${formatted}`;
}

// format dates
const isValidDate = (date) => moment(date, moment.ISO_8601, true).isValid();

const formatSingleDate = (date, dateFormat) => {
  if (isValidDate(date)) {
    return moment(date).format(dateFormat);
  }
  return ""; // Default return for invalid date
};

export function formatDates(dates, dateTimeFormat = false) {
  const dateFormat = dateTimeFormat ? DATE_TIME_FORMAT : DATE_FORMAT;
  if (Array.isArray(dates)) {
    return dates.map((date) => formatSingleDate(date, dateFormat));
  }
  return formatSingleDate(dates, dateFormat);
}

// convert local date
export function convertToLocalDate(dateInput) {
  const date = new Date(dateInput);

  if (isNaN(date.getTime())) {
    throw new Error(
      "Invalid date input. Please provide a valid date string or Date object."
    );
  }
  const localOffset = date.getTimezoneOffset() * 60000;
  const localDate = new Date(date.getTime() - localOffset);
  return localDate.toISOString().split("T");
}

//handle error api
export function handleApiError(error, showNotification) {
  console.error(error.message);
  if (showNotification) {
    const errorMessage =
      error.response?.data?.errorMessage || "An error occurred";
    showNotification("error", errorMessage);
  }
}

// save last page
export function saveLastPageToLocalStorage(pageName, id, idNo) {
  const latestPages = JSON.parse(localStorage.getItem("latestPages")) || {};
  latestPages[pageName] = { id: id, name: idNo };
  localStorage.setItem("latestPages", JSON.stringify(latestPages));
}

// convert title
export function convertToTitleCase(key) {
  return key
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^\w/, (c) => c.toUpperCase());
}

export function onMakeChange(value, makeOptions) {
  return findSelectedLabel(value, makeOptions);
}
export function onModelChange(value, modelOptions) {
  return findSelectedLabel(value, modelOptions);
}
export function onSeriesChange(value, seriesOptions) {
  return findSelectedLabel(value, seriesOptions);
}

export function findSelectedLabel(id, data) {
  return data.find((item) => item.id === id)?.name;
}

export function getCookies(key) {
  return Cookies.get(key);
}

export function setCookies(key, value) {
  console.log({ key, value });

  return Cookies.set(key, value);
}

export const parseJSON = (value, defaultValue) => {
  try {
    return JSON.parse(value) ?? defaultValue;
  } catch {
    return defaultValue;
  }
};

export const preventNonNumericKey = (evt) => {
  if (["e", "E", "+", "-"].includes(evt.key)) {
    evt.preventDefault();
  }
};

export const blockNonDigitInput = (evt) => {
  const key = evt.key;
  // Cho phép các phím điều khiển
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "Escape",
    "Enter",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "Ctrl",
    "Alt",
    "Shift",
    "Meta",
  ];

  if (evt.ctrlKey || evt.metaKey) return;

  // Chặn nếu không phải là số và không nằm trong danh sách cho phép
  if (!/^\d$/.test(key) && !allowedKeys.includes(key)) {
    evt.preventDefault();
  }
};

export const preventNonNumericPaste = (evt) => {
  const pasteData = evt.clipboardData.getData("text");
  if (isNaN(Number(pasteData))) {
    evt.preventDefault();
  }
};

export const preventInvalidPhoneKey = (evt) => {
  const key = evt.key;

  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

  if (allowedKeys.includes(key) || evt.ctrlKey || evt.metaKey) {
    return;
  }

  if (!/^\d$/.test(key)) {
    evt.preventDefault();
  }
};

export const getFromToDate = (dates) => {
  if (!dates || dates.length < 2)
    return {
      fromDate: null,
      toDate: null,
    };
  const [first, second] = dates;
  return {
    fromDate: first < second ? first : second,
    toDate: first < second ? second : first,
  };
};

export const downloadFile = ({ source, filename = "downloaded-file" }) => {
  const link = document.createElement("a");
  let url = "";

  if (source instanceof Blob) {
    url = URL.createObjectURL(source);
  } else {
    url = source;
  }

  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up Blob URL
  if (source instanceof Blob) {
    URL.revokeObjectURL(url);
  }
};
